import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { resetPassword } = useAuth();
  const { t, language } = useLanguage();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setSubmitting(true);
    try {
      await resetPassword(email, language);
      setMessage(t('auth.reset.success'));
    } catch {
      setError(t('auth.reset.error'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4 py-6">
      <div className="w-full max-w-md space-y-4 sm:space-y-6">
        <div className="flex justify-center">
          <img
            src="/rentalyzer-logo.png"
            alt="Rentalyzer logo"
            className="h-24 sm:h-48 w-auto"
          />
        </div>
        <div className="p-5 sm:p-8 space-y-6 bg-white rounded shadow">
        <h2 className="text-xl sm:text-2xl font-bold text-center">{t('auth.reset.title')}</h2>
        {error && <div className="p-2 text-red-600 bg-red-100 rounded">{error}</div>}
        {message && <div className="p-2 text-green-600 bg-green-100 rounded">{message}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium">{t('auth.email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border rounded"
              required
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="w-full py-2 text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-60"
          >
            {submitting ? t('loading') : t('auth.reset.submit')}
          </button>
        </form>
        <div className="text-sm text-center">
          <Link to={`/login${location.search}`} className="text-blue-600 hover:underline">
            {t('auth.backToLogin')}
          </Link>
        </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
